module.exports = __webpack_public_path__ + "img/icon4.4c707dbb.png";